<app-header></app-header>

<router-outlet></router-outlet>

<app-footer></app-footer>

<app-loading-overlay></app-loading-overlay>
